/* eslint-disable import/export */
export * from './isMatched';

const lastHandle = 0;

export function ensureHandle(entity: any) {
    if (!entity) {
        throw new TypeError('entity cannot be undefined or null');
    }

    // Make a copy of the entity to avoid modifying the parameter directly
    const updatedEntity = { ...entity };

    if (!updatedEntity.handle) {
        updatedEntity.handle = lastHandle + 1;
    }

    return updatedEntity; // Return the modified copy instead of modifying the parameter
}
